import { requestAxios } from './api';
import { obterInfoNavegador } from '../util';

export async function serviceCriarFiliacao(objetoEnvio) {
    try {
        const retorno = await requestAxios('POST', 'Filiacao', 'create', objetoEnvio);
        return retorno;
    } catch (error) {
        console.error('Erro ao criar filiação:', error);
        throw error;
    }
}

export async function serviceSalvarArquivos(objetoEnvio) {
    try {
        const retorno = await requestAxios('POST', 'Filiacao', 'upload-files', objetoEnvio, true);
        return retorno;
    } catch (error) {
        console.error('Erro ao adicionar arquivos:', error);
        throw error;
    }
}

export async function serviceRecuperaCidades(estado) {
    try {
        const retorno = await requestAxios('GET', 'EstadoCidade', `getCidadesByUf?uf=${estado}`);
        return retorno;
    } catch (error) {
        console.error('Erro ao recuperar cidades:', error);
        throw error;
    }
}

export async function serviceRecuperaHash(idFiliacao) {
    try {
        const retorno = await requestAxios('GET', 'Filiacao', `get-hash/${idFiliacao}`);
        return retorno;
    } catch (error) {
        console.error('Erro ao recuperar cidades:', error);
        throw error;
    }
}

export function serviceViaCep(cep, callback) {
    fetch(`https://viacep.com.br/ws/${cep.replace(/\D/g, '')}/json/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => {
            return response.json();
        })
        .then(data => {
            callback(data);
        })
        .catch(error => {
            console.error('Erro na requisição:', error);
        });
}

export async function serviceEnviaEmail(objetoEnvio) {
    try {
        const retorno = await requestAxios('POST', 'Filiacao', 'send-mail', objetoEnvio, true);
        return retorno;
    } catch (error) {
        console.error('Erro ao enviar e-mail:', error);
        throw error;
    }
}

export async function serviceRecuperaFiliais() {
    try {
        const retorno = await requestAxios('GET', 'Filiais', `get-all`);
        return retorno;
    } catch (error) {
        console.error('Erro ao recuperar filiais:', error);
        throw error;
    }
}

// export function serviceRecuperaQuantidadeRejeitados(cpf, callback) {
//     const baseURL = process.env.REACT_APP_API_URL;
//     fetch(`${baseURL}api/Filiacao/get-quant-rejeitados/${cpf}`, {
//         method: 'GET',
//         headers: {
//             'Content-Type': 'application/json'
//         }
//     })
//         .then(response => {
//             return response.json();
//         })
//         .then(data => {
//             callback(data);
//         })
//         .catch(error => {
//             console.error('Erro ao recuperar quantidade de filiados rejeitados por cpf:', error);
//         });
// }


export async function serviceRecuperaQuantidadeRejeitados(cpf, callback) {
    try {
        const cpfSemMascara = cpf.replace(/\D/g, '');

        const resultado = await requestAxios(
            'GET',
            'Filiacao',
            `get-quant-rejeitados/${cpfSemMascara}`
        );

        callback(resultado);
    } catch (error) {
        console.error('Erro ao verificar cadastro do CPF:', error);
    }
}




export async function serviceRecuperaOperacoes() {
    try {
        const retorno = await requestAxios('GET', 'Banco', `operacoes`);
        return retorno;
    } catch (error) {
        console.error('Erro ao recuperar operações:', error);
        throw error;
    }
}

export async function serviceSalvarLog(metodo, mensagem, payload, nivel = 'ERROR', trackId = '') {
    try {
        const { navegador, sistemaOperacional, userAgent } = obterInfoNavegador();

        const formData = new FormData();
        formData.append('trackId', trackId || 'nd');
        formData.append('nivel', nivel || 'ERROR'); // INFO, WARNING, ERROR
        formData.append('navegador', navegador);
        formData.append('sistemaOperacional', sistemaOperacional);
        formData.append('userAgent', userAgent);
        formData.append('mensagem', mensagem || 'nd');
        formData.append('metodo', metodo || 'nd');
        formData.append('payload', payload || 'nd');
        
        const retorno = await requestAxios('POST', 'Filiacao', 'salva-log-front', formData, true);
        return retorno;
    } catch (error) {
        // Não faz throw para não quebrar o fluxo principal
        console.error('Erro ao salvar log (não crítico):', error);
        return null;
    }
}


